<template>
  <AdvancedAccordion
    :name="`${$t('common.setSameAs')} ${items[0].description}`"
    v-for="(items, index) in groupedSets"
    :key="index">
    <template #hover-content v-if="mode == 'edit'">
      <div class="flex items-center gap-3 text-slate-600">
        <button
          type="button"
          class=""
          @click="
            onEditDelete($event, items, 'edit', `${$t('common.setSameAs')} ${items[0].description}`)
          ">
          <Icon icon="ph:pencil-simple" class="w-4 h-4" />
        </button>
        <button
          type="button"
          class=""
          @click.stop="
            onEditDelete(
              $event,
              items,
              'delete',
              `${$t('common.setSameAs')} ${items[0].description}`
            )
          ">
          <Icon icon="tdesign:delete-1" class="w-4 h-4" />
        </button>
      </div>
    </template>
    <template #controls
      ><div class="flex items-center gap-2 text-sm font-light">
        {{ $t('warehouse.minQuantity') }}
        <div
          class="flex items-center justify-center w-6 h-6 text-sm text-white rounded bg-theme-700">
          {{ items[0].minQuantity }}
        </div>
      </div>
    </template>
    <template #content>
      <div
        v-for="(item, index) in items"
        :key="item.id"
        class="flex p-3 text-sm font-light border-b group hover:bg-gray-50">
        {{ item.description }}
        <button
          v-if="mode == 'edit'"
          type="button"
          class="invisible ml-auto mr-4 border-0 group-hover:visible"
          @click="
            onEditDelete(
              $event,
              items,
              'delete',
              `${$t('common.setSameAs')} ${items[0].description}`,
              index
            )
          ">
          <Icon icon="tdesign:delete-1" class="w-4 h-4 text-slate-500" />
        </button>
      </div>
    </template>
  </AdvancedAccordion>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { AssortmentDetails } from '@/types/Materials';
import AdvancedAccordion from '../common/AdvancedAccordion.vue';
import { Icon } from '@iconify/vue';

const props = defineProps<{
  sets: AssortmentDetails[];
  mode: 'edit' | 'view';
}>();

const emit = defineEmits(['edit', 'delete']);

const groupedSets = computed(() => {
  return props.sets.reduce((groups: any, item) => {
    const { similarID } = item;
    if (!similarID) return;
    if (!groups[similarID]) groups[similarID] = [];
    groups[similarID].push(item);
    return groups;
  }, {});
});

function onEditDelete(
  event: Event,
  items: AssortmentDetails[],
  action: 'edit' | 'delete',
  name: string,
  removeIndex?: number
) {
  event.stopPropagation();
  emit(action, { items, name, removeIndex });
}
</script>
